import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import beforeEnter from '@/router/beforeEnter'
import commonRouters from '@/router/routers/common'
import dashboardRouters from '@/router/routers/dashboard'
import demandRouter from '@/router/routers/demand'
import collaboratorRouter from '@/router/routers/collaborator'
import staffRouter from '@/router/routers/staff'
import benefitsRouter from '@/router/routers/club'
import notificationRouter from '@/router/routers/notification'
import contractRouter from '@/router/routers/contract'
import corporateRouter from '@/router/routers/corporate'
import brandRouter from '@/router/routers/brand'
import clientRouter from '@/router/routers/client'
import departamentRouter from '@/router/routers/departament'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    linkExactActiveClass: 'exact-active',
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        ...commonRouters(beforeEnter),
        dashboardRouters(beforeEnter),
        demandRouter(beforeEnter),
        ...collaboratorRouter(beforeEnter),
        ...staffRouter(Vue, beforeEnter),
        ...benefitsRouter(beforeEnter),
        notificationRouter(beforeEnter),
        contractRouter(beforeEnter),
        corporateRouter(beforeEnter),
        brandRouter(beforeEnter),
        ...departamentRouter(
            beforeEnter,
            'Departamentos',
            'Departamento',
            '/departamentos',
            {
                info: true,
                demand: true,
                timeline: true,
                workedHour: true,
                contract: true,
                corporate: false,
                brand: false,
                collaborator: true
            },
            false,
            {
                detailTo: 'DepartamentoAbaInternaDemandasAtivas',
                showInatives: true,
                showEdit: true
            }
        ),
        ...clientRouter(
            beforeEnter,
            'Portfolios',
            'Portfolio',
            '/portfolios',
            {
                info: true,
                demand: true,
                timeline: true,
                workedHour: true,
                contract: true,
                corporate: true,
                brand: true,
                collaborator: true
            },
            true,
            {
                detailTo: 'PortfolioAbaInternaDemandasAtivas',
                showInatives: true,
                showEdit: true
            }
        )
    ]
})

router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
})

router.afterEach((to, from) => {
    NProgress.done()
})

export default router
